module.exports = __webpack_public_path__ + "img/5.d22a3de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/5.png
// module id = 209
// module chunks = 1